"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessRoleToJSON = exports.BusinessRoleFromJSONTyped = exports.BusinessRoleFromJSON = exports.BusinessRole = void 0;
/**
 * The role of the user in a business.
 * @export
 */
exports.BusinessRole = {
    Admin: 'BUSINESS_ADMIN',
    Member: 'BUSINESS_MEMBER'
};
function BusinessRoleFromJSON(json) {
    return BusinessRoleFromJSONTyped(json, false);
}
exports.BusinessRoleFromJSON = BusinessRoleFromJSON;
function BusinessRoleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.BusinessRoleFromJSONTyped = BusinessRoleFromJSONTyped;
function BusinessRoleToJSON(value) {
    return value;
}
exports.BusinessRoleToJSON = BusinessRoleToJSON;
